import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Order } from "../../orders.types";
import { requestGetOrders } from "./getOrders.request";

const useGetOrders = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<Order>, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["order", "admin", "all", requestParams],
    queryFn: async () => await requestGetOrders(requestParams),
    onError: toastServerError,
    ...options
  });

  return { orders: data?.data, meta: data?.meta, ...rest };
};

export default useGetOrders;
